<div class="login-main-wrapper">
  <div class="inner-wrapper d-flex flex-column flex-lg-row">
    <div class="">
      <app-left-layout></app-left-layout>
    </div>
    <div
      class="login-right-side flex-fill d-flex flex-column justify-content-center align-items-center vh-100 overflow-lg-auto position-relative">
      <!-- <app-google-translate></app-google-translate> -->
      <div class="right-content  p-3 p-lg-0">
        <div class="mb-0  ">
          <!-- <img src="assets/images/icons/back-arrow-circle.svg" class="cursor mb-4" alt="" *ngIf="method != 'email'"
          (click)="resetForm()"> -->
          @if (method == type.email && !showPasswordContainer) {
            <h2 class="fs-32 fw-700 m-0 mb-2">
              Welcome Back!
            </h2>
          }
          @if (method != type.email) {
            <h2 class="fs-32 fw-700 m-0 mb-2">
              Verification Code Sent
            </h2>
          }
          @if (method == type.email && !showPasswordContainer) {
            <p class="fs-16 fw-500 text-custom-color m-0 mb-4">
              Enter your details to continue your journey.
            </p>
          }

          @if (method == type.email && !showPasswordContainer) {
            <div>
              <div class="mt-3">
                <app-google-sign-in></app-google-sign-in>
              </div>
              <div class="row m-0">
                <div class="col p-0 text-secondary">
                  <hr class="w-100">
                </div>
                <div class="col-1 p-0"><span class="w-100 fs-12 fw-500 text-center text-secondary ms-2">Or</span></div>
                <div class="col p-0 text-secondary">
                  <hr class="w-100">
                </div>
              </div>
            </div>
          }
        </div>

        <form [formGroup]="loginForm" class="col-12">

          @if (method == type.email && !showPasswordContainer) {
            <div class=" form-group mt-2 mb-3">
              <div
                [ngClass]="[ (loginForm.controls['email'].touched && loginForm.controls['email'].invalid) ? 'custom-form  inputContainer' : 'custom-form']"
                class="mb-3">
                <label for="text" class="label-name fs-14 fw-700 w-100">
                  Enter your email or phone number
                </label>
                <input type="text" [mask]="mask"  class="input_field w-100" name="email" required formControlName="email" (keydown.space)="onSpace($event)"  (input)="onEmailInput($event)"
                  placeholder="Enter Your Email or Phone number" />
                  @if ((loginForm.controls['email'].touched && loginForm.controls['email'].invalid)) {
                    <p class="mat-error text-danger w-100 d-block mb-2 fs-14"
                      >
                    {{loginForm.controls['email'].errors ? 'Please enter a valid Email/Phone Number' : ''}} </p>
                  }
                </div>
                @if (loginForm.controls['email'].value && !showPasswordContainer) {
                  <div class=" form-group">
                    <div class="w-100 align-items-center justify-content-between mb-3">
                      <button class=" px-4 border-0 text-black  btn btn-secondary fs-16 fw-700 w-100" [disabled]="$safeNavigationMigration(loginForm.get('email')?.invalid)" (click)="showPasswordContainer = true">
                      Enter Password </button>
                    </div>
                    <!-- <button class=" px-4 btn btn-secondary light  fw-600  w-100 mb-3"
                    [disabled]="( loginForm.controls['email'].invalid)" (click)="method ='password'">Enter
                  Password</button> -->
                  <button class=" px-4 btn btn-outline btn-color fs-16 fw-700 w-100 mb-3" (click)="logInType(type.OTP)">Get
                  Verification Code Via {{ otpLabel }}</button>
                  <!-- <div class="row m-0">
                  <div class="col p-0">
                    <hr class="w-100">
                  </div>
                  <div class="col-1 p-0"><span class="w-100 text-center ms-2">or</span></div>
                  <div class="col p-0">
                    <hr class="w-100">
                  </div>
                </div> -->
                <div class="mt-3">
                  <!-- <app-google-sign-in></app-google-sign-in> -->
                </div>
              </div>
            }
            <p class="fs-14 fw-500 m-0 text-secondary text-center">
              Don't have an account?
              <span class="fw-700 link-text cursor text-primary" [routerLink]="'/register'">Sign Up</span>
            </p>
          </div>
        }

        @if (showPasswordContainer) {
          <h2 class="fs-32 fw-700 m-0 mb-2">
            Enter Your Password
          </h2>
          <p class="fs-16 fw-400 text-custom-color m-0 mb-3">
            Welcome back — let’s make progress together.
          </p>
          <label for="text" class="label-name text-custom-color fs-14 fw-700 w-100">
            Password
          </label>
          <div class="position-relative">
            <input [type]="showPassword ? 'text' : 'password'" class="input_field w-100  mb-2" name="email" required
              formControlName="password" placeholder="Enter Your Password" />
              <img [src]="showPassword ? 'assets/images/icons/open-eye.svg' : 'assets/images/icons/close-eye.svg'" alt=""
                class="position-absolute eye-icon cursor" (click)="showPassword = !showPassword">
              </div>
              @if (((loginForm.controls['password'].invalid && loginForm.controls['password'].touched))) {
                <p class="mat-error text-danger w-100 d-block fs-14 mb-0"
                  >
                  {{( (loginForm.controls['password'].errors) || (loginForm.controls['password'].invalid &&
                loginForm.controls['password'].touched)) ? 'Please enter a valid Password' : ''}}</p>
              }
              <div class=" mt-0 w-100 text-start">
                <p>
                  <a routerLink="/forgot-password"
                  class="fw-600 cursor  d-inline-block d-blue decoration-none fs-14 text-primary">Forgot Password?</a>
                </p>
              </div>
              <button class=" mb-2 px-4 border-0 text-black  btn btn-secondary fs-16 fw-700 w-100" (click)="login()">
              Log In </button>
              <button class=" px-4 btn btn-default light fs-16 fw-700 w-100" (click)="showPasswordContainer = false">
              Back To Login </button>
            }


            <!-- <ng-container *ngIf="method == type.password"> -->
            <!-- <button class=" px-4 border-0 btn btn-primary fs-16 fw-600" (click)="logInType(type.email)">Back</button> -->
          <!-- </ng-container> -->

          @if (method == type.OTP) {
            <div class="mb-4">
              <p class="fs-16 fw-400 text-custom-color m-0">
                We’ve sent a 6-digit verification code to <br> <span class="fs-16 fw-400 text-primary">{{ formatInput(loginForm.controls['email'].value) }}.</span> Enter the code below to verify and continue.
              </p>
            </div>
            <div class=" form-group mt-2">
              <!-- <p class="fs-14 fw-400">Enter Verification Code</p> -->
              <form [formGroup]="otpForm" action="" (keydown.enter)="verifyOtp()">
                <div class="form-group otp_fields new-otp_fields mb-3 mt-2 d-flex justify-content-between">
                  @for (item of otpValueGroup; track item; let index = $index) {
                    <input id={{item}} (input)="onInput($event, index); verifyOtp()"
                      (keydown.Tab)="$event.preventDefault()" (keydown.space)="$event.preventDefault()"
                      (keydown.backspace)="onDelete($event , index)" formControlName="{{item}}" type="text" maxlength="1"
                      placeholder="-"
                      (paste)="onPasteHandler($safeNavigationMigration($event.clipboardData?.getData('text/plain')))"/>
                  }
                </div>
              </form>
            </div>
            @if (countdown > 0) {
              <div class="mb-4 fs-14 fw-500 text-secondary ">Didn’t receive the code? Resend in <span class="fw-700 text-custom-color">{{ formatTime(countdown) }}</span>
            </div>
          }
          @if (countdown <= 0) {
            <div class="mb-4 fs-14 fw-500 text-secondary ">Didn’t receive the code? <a class="color-blue cursor" (click)="renewOtp()">Resend Code</a></div>
          }
          <div class="w-100 d-flex align-items-center justify-content-center mb-3">
            <button class=" px-4 border-0  btn btn-secondary fs-16 fw-700 w-100" (click)="verifyOtp()">
            Verify & Continue</button>
            <!-- <button class=" px-4 border-0 btn btn-primary fs-16 fw-600" (click)="logInType(type.email)">Back</button> -->
          </div>
          <div class="w-100 d-flex align-items-center justify-content-center mb-3">
            <button class=" px-4 btn btn-default light fs-16 fw-700 w-100" (click)="resetForm()">
            Back To Login </button>
          </div>
          <p class="fs-14 fw-500 mt-3 text-secondary">🔒 Your information is securely encrypted.</p>
        }
        <!--
        <div class="  mt-2 w-100 text-end">
          <p>
            <a routerLink="/forgot-password" class="fw-600 cursor  d-block d-blue decoration-none fs-14 text-primary">Forgot Password</a>
          </p>
        </div> -->


      </form>


    </div>
    <div class="footer bottom-10 position-absolute"> © FinanceMutual<sup>TM</sup> {{_shared.today | date:"yyyy"}}</div>
  </div>
</div>
</div>